import React from "react";
import { Route, Routes } from "react-router-dom";
import { LabelPrintingList } from "./containers";

export const LabelPrinting = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LabelPrintingList />} />
      </Routes>
    </>
  );
};
